import makeApiRequest from './makeApiRequest';

export default async function submitDocs(account, instance, completed, document) {
    return await makeApiRequest(account, instance, 'put', 'SubmitDocument?completed=' + completed, document);
}